<template>
  <v-card>
    <v-container>
      <v-card-title>
        <span class="pl-1 primary--text">Ver datos de acceso</span>
        <v-col cols="1" md="1" class="justify-center pt-2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="primary--text" v-on="on" v-bind="attrs">{{
                infoIcon
              }}</v-icon>
            </template>
            <span
              >Información general para conectarse al cliente. <br />Ejemplos: <br />"Conectarse vía
              Teamviewer. Buscar cliente en lista de ordenadores"
              <br />"Conectarse vía AnyDesk, usuario 123 456 885, contraseña,
              Mcn3434" <br />"La conexión por RDP llega al server de datos, de
              ahí conectarse a 192.168.158 para ir al de aplicaciones"
              <br />Etc.
            </span>
          </v-tooltip>
        </v-col>
      </v-card-title>

      <v-card-text class="pb-0">
        <v-row>
          <!-- Textarea para mostrar el texto -->
          <v-col cols="12" md="12" class="py-0">
            <v-textarea
              v-model="datosTexto"
              label="Texto"
              dense
              auto-grow
              rows="8"
              outlined
              readonly
              filled
            ></v-textarea>
          </v-col>
          <v-col cols="12" md="12" class="py-0">
            <v-switch
              class="py-0"
              v-model="habilitado"
              label="Habilitado"
              dense
              outlined
              disabled
              readonly
            ></v-switch>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined @click="closeModal()"> Cerrar </v-btn>
      </v-card-actions>
    </v-container>
  </v-card>
</template>

<script>
import enums from "@/utils/enums/index.js";

export default {
  name: "VerDatosAcceso",
  props: {
    datosTexto: {
      type: String,
      required: true,
      default: ""
    },
    habilitado: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data: () => ({
    infoIcon: enums.icons.SNB_INFO,
  }),
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>

<style scoped></style>